<template>
  <v-container
    id="app-loyalty-jackpot"
    class="pa-1"
  >
    <screen
      :title="$t('field.loyalty.solde')"
      :info="$amount(solde)"
      :titlesup="captureAmount ? $t('field.loyalty.amount_use') : null"
      :infosup="$amount(total)"
      infoclass="green--text"
      use-amount
    />

    <!-- ***** BOUTONS D'ACTION ***** -->
    <div
      v-show="!captureAmount"
      class="pt-3"
    >
      <!-- ****************************************
      ********** CHOIX PAIEMENT CAGNOTTE **********
      ***************************************** -->
      <v-btn
        class="ma-0 half-large"
        @click="captureAmount = true"
      >
        {{ $t('field.loyalty.part_pay') }}
      </v-btn>

      <v-btn
        class="ma-0 half-large right"
        @click="useFullJackpot"
      >
        {{ $t('field.loyalty.pay', { amount: $amount(jackpotAmount) }) }}
      </v-btn>

      <v-btn
        class="mt-4 large"
        block
        @click="dontUseJackpot"
      >
        {{ $t('field.loyalty.dont_use') }}
      </v-btn>
    </div>

    <!-- ***** SAISIE MONTANT ***** -->
    <keyboard
      v-show="captureAmount"
      v-model="total"
      :max="hasLeftToPay ? solde : amount"
      @del="captureAmount = false"
      @cancel="captureAmount = false"
      @valid="valid"
    />
  </v-container>
</template>

<script>
import { Scan } from '@/modules/Scan'
import { $alert, $amount, createReference } from '@/modules/Utils'

export default {
  name: 'LoyaltyJackpotView',

  props: {
    idBadge: { type: String, required: true },
    carrier: { type: Object, default: null },
    solde: { type: Number, default: 0 },
    idAchat: { type: [String, Number], default: null },
    ticket: { type: Object, default: null },
    clientQuestions: { type: Object, default: null },
    loyaltyQuestions: { type: Object, default: null }
  },

  data () {
    return {
      captureAmount: false,
      total: 0,
      reference: createReference()
    }
  },

  computed: {
    amount () { return this.$store.state.amount },
    postJackpot () { return this.$store.getters.postJackpot },
    jackpotAmount () { return this.hasLeftToPay ? this.solde : this.amount },
    hasLeftToPay () { return this.amount > this.solde }
  },

  beforeMount () {
    if (!this.idBadge) {
      this.$router.replace('/')
    } else {
      this.$emit('title', this.$i18n.t('title.loyalty_jackpot'))
    }
  },

  methods: {
    $amount,
    startDebit () {
      Scan.launchDebit(this.idBadge, 'P', '', this.solde,
        (response) => {
          if (response !== null) {
            this.$router.replace({
              name: 'ticket',
              params: {
                tickets: [this.ticket, response],
                leftToPay: this.total !== 0 ? (this.amount - this.total) : (this.hasLeftToPay ? (this.amount - this.solde) : 0),
                carrier: this.carrier
              }
            })
          }
        },
        (error) => {
          $alert(error)
        },
        false,
        this.idAchat,
        this.total !== 0 ? this.total : (this.hasLeftToPay ? this.solde : this.amount),
        false,
        this.reference
      )
    },
    startFidCalcul () {
      // Appel à la route fidCalcul
      Scan.launchFidCalcul(
        this.idBadge,
        (error) => {
          $alert(error)
          this.total = 0
          this.showKeyboard = false
        },
        null,
        null,
        null,
        this.total,
        this.solde,
        this.reference
      )
    },
    useFullJackpot () {
      this.total = this.jackpotAmount
      this.valid()
    },
    dontUseJackpot () {
      if (this.postJackpot) {
        this.valid()
      } else {
        this.$router.replace({
          name: 'ticket',
          params: {
            tickets: [this.ticket],
            leftToPay: this.amount,
            carrier: this.carrier
          }
        })
      }
    },
    // ********** KEYBOARD **********
    valid () {
      if (this.postJackpot) {
        if (this.clientQuestions || this.loyaltyQuestions) {
          this.$router.replace({
            name: 'loyalty-questions',
            params: {
              idBadge: this.idBadge,
              clientQuestions: this.clientQuestions,
              loyaltyQuestions: this.loyaltyQuestions,
              solde: this.solde,
              postJackpotAmount: this.total
            }
          })
        } else {
          this.startFidCalcul()
        }
      } else if (this.total > 0) {
        this.startDebit()
      }
    }
  }
}
</script>
